import Icon from '@mdi/react'
import type { IconProps } from '.'

const collectionsSvg = `M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2m-11-4 2.03 2.71L16 11l4 5H8zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6z`

const collectionsOutlinedSvg = `M20 4v12H8V4zm0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8.5 9.67 1.69 2.26 2.48-3.1L19 15H9zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6z`

const PrivateGallery = (props: IconProps) => {
    const { filled, color, title, size = 1 } = props
    return (
        <Icon
            data-testid="Icon__PrivateGallery"
            path={filled ? collectionsSvg : collectionsOutlinedSvg}
            title={title}
            color={color}
            size={size}
        />
    )
}

export default PrivateGallery
